import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { trainingApi, expenseApi } from "../../services";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { trainingStatusList } from '../../common/util/constants';

const UpdateEmpTrainingDetail = ({ clickedRowData, closeDialoge, reload }) => {
  const fileUploadRef = useRef(null);

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      targetSkill: clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '',
      projectName: clickedRowData?.projectName ? clickedRowData?.projectName : '',
      categoryOfTraining: clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '',
      trainingType: clickedRowData?.trainingType ? clickedRowData?.trainingType : '',
      startDate: clickedRowData?.startDate ? moment(clickedRowData?.startDate).format("YYYY-MM-DD") : '',
      endDate: clickedRowData?.startDate ? moment(clickedRowData?.endDate).format("YYYY-MM-DD") : '',
      trainingDetailStatus: clickedRowData?.trainingDetailStatus ? clickedRowData?.trainingDetailStatus : null,
      assignedCourseHours: clickedRowData?.assignedCourseHours ? clickedRowData?.assignedCourseHours : '0',
      assignedCourseMinutes: clickedRowData?.assignedCourseMinutes ? clickedRowData?.assignedCourseMinutes : '0',
      completedCourseHours: clickedRowData?.completedCourseHours ? clickedRowData?.completedCourseHours : '',
      completedCourseMinutes: clickedRowData?.completedCourseMinutes ? clickedRowData?.completedCourseMinutes : '',
      progressUpdate: clickedRowData?.progressUpdate ? clickedRowData?.progressUpdate : '',
      // trainingCompletePercentage: clickedRowData?.percentage ? clickedRowData?.percentage : '',
      trainingDocument: [],
      trainingLearning: clickedRowData?.trainingLearning ? clickedRowData?.trainingLearning : '',
      learningApplyOnProject: clickedRowData?.learningApplyOnProject ? clickedRowData?.learningApplyOnProject : '',
    },
    validate: (data) => {
      let errors = {};

      if (!data.trainingDetailStatus) errors.trainingDetailStatus = "Status is required";
      // if (!data.trainingCompletePercentage) errors.trainingCompletePercentage = "Progress Percentage is required";
      // if (data.trainingCompletePercentage > 100) errors.trainingCompletePercentage = "Progress Percentage should be less than or equal to 100";
      if (data.assignedCourseHours !== '') {
        if (data.completedCourseHours > data.assignedCourseHours || data.completedCourseMinutes > data.assignedCourseMinutes) errors.completedCourseHours = "Course Hours should be less than or equal to " + data.assignedCourseHours + ":" + data.assignedCourseMinutes + " hours";
      }
      if (!data.progressUpdate) errors.progressUpdate = "Progress Update is required";
      if(data.trainingDetailStatus === 2){
        if (!data.trainingDocument || data.trainingDocument.length === 0) errors.trainingDocument = "Document upload is required";
      }
      

      return errors;
    },
    onSubmit: (data) => {
      let ids = [];
      data?.trainingDocument.map(doc => {
        ids.push(doc.id);
      });
      let completedTrainingDate = new Date();

      let params = {
        "id": clickedRowData.id,
        "userId": clickedRowData.userId,
        "targetSkill": clickedRowData.targetSkill,
        "projectName": data.projectName,
        "categoryOfTraining": clickedRowData.categoryOfTraining,
        "trainingType": clickedRowData.trainingType,
        "trainingDetailStatus": data.trainingDetailStatus,
        "completedCourseHours": data.completedCourseHours ? parseInt(data.completedCourseHours) : 0,
        "completedCourseMinutes": data.completedCourseMinutes ? data.completedCourseMinutes : '0',
        "startDate": data.startDate,
        "endDate": data.endDate,
        "progressUpdate": data.progressUpdate,
        "percentage": data.trainingDetailStatus === 2 ? 100 : 0,
        "DocumentUpload": ids,
        "trainingLearning": data.trainingLearning,
        "completeDateOfTraining": data.trainingDetailStatus === 2 ? moment(completedTrainingDate).format("YYYY-MM-DD") : null,
        "learningApplyOnProject": data.learningApplyOnProject
      }
      try {
        trainingApi.updateEmployeeTraining(params).then(
          (resp) => {
            fileUploadRef.current.clear();
            toast.success(resp.data.message);
            setTimeout(() => {
              closeDialoge();
              reload();
            }, 1000);
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to update");
      }
    },
  });



  const uploadFiles = (e) => {
    // trainingApi.uploadTrainingFiles(e.files, clickedRowData?.id).then(resp => {
    trainingApi.uploadTrainingFiles(e.files).then(resp => {
      if (resp.data.error) {
        toast.error(resp.data.error.data);
        return;
      }
      const uploadedFileUrl = resp.data.data;
      formik.setFieldValue(`trainingDocument`, uploadedFileUrl);
      const totalDocs = document.querySelectorAll(".p-fileupload-file-badge");
      for (let index = 0; index < totalDocs.length; index++) {
        totalDocs[index].innerHTML = "Uploaded"
      }
    })
  };

  return (
    <>
      <hr />
      <div className="card">
        <form onSubmit={formik.handleSubmit} autoComplete='off'>
          <div className="card">
            <div className="flex flex-wrap p-field font-bold block">
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Target Skill
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="targetSkill" value={formik.values.targetSkill} onChange={formik.handleChange} disabled placeholder="Skills" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Project Name
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="projectName" value={formik.values.projectName} onChange={formik.handleChange} disabled placeholder="Project" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Category Of Training
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="categoryOfTraining" value={formik.values.categoryOfTraining} onChange={formik.handleChange} disabled placeholder="Category" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Training Type
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="trainingType" value={formik.values.trainingType} onChange={formik.handleChange} disabled placeholder="Self Paced" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Start Date
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="startDate" value={formik.values.startDate} onChange={formik.handleChange} disabled placeholder="Start Date" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  End Date
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="endDate" value={formik.values.endDate} onChange={formik.handleChange} disabled placeholder="End Date" className="w-full" />
                </div>
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Training Status
                </label>
                <div className="p-inputgroup flex-1">
                  {/* <InputText name="trainingDetailStatus" value={formik.values.trainingDetailStatus} onChange={formik.handleChange} disabled placeholder="30-11-2024" className="w-full" /> */}
                  <Dropdown name="trainingDetailStatus" value={formik.values.trainingDetailStatus} onChange={(e) => formik.handleChange(e)} options={trainingStatusList} optionValue="id" optionLabel="title" placeholder="Select Status" className="w-full" />
                </div>
                {getFormErrorMessage('trainingDetailStatus')}
              </div>
              <div className="col-3">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Completed Course Duration
                </label>
                <div className="p-inputgroup flex-1">
                  <InputText name="completedCourseHours" value={formik.values.completedCourseHours} onChange={formik.handleChange} placeholder="Course Hours" className="w-full" />
                  <InputText name="completedCourseMinutes" value={formik.values.completedCourseMinutes} onChange={formik.handleChange} placeholder="Course Minutes" className="w-full" />
                </div>
                {getFormErrorMessage('completedCourseHours')}
              </div>
              <div className="col-6">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Progress Update
                </label>
                <div className="p-inputgroup flex-1">
                  <InputTextarea name="progressUpdate" value={formik.values.progressUpdate} onChange={formik.handleChange} placeholder="Enter Your Progress" rows={7} className="w-full" style={{ background: "#fff" }} />
                </div>
                {getFormErrorMessage('progressUpdate')}
              </div>
              <div className="col-6">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Documents Upload <span style={{ color: 'red' }}>(Only upload .jpg, .jpeg, .png, .pdf)</span>
                </label>
                <div className="w-full">
                  {/* <FileUpload name="demo[]" url={"/api/upload"} multiple accept="image/*" maxFileSize={1000000} emptyTemplate={<p className="m-0 w-full">Drag and drop files to here to upload.</p>} /> */}
                  <FileUpload onRemove={(e) => formik.setFieldValue(`trainingDocument`, formik.values.trainingDocument.filter(item => item?.fileName.split('-')[1] !== e?.file?.name))}
                    maxFileSize={2097152} ref={fileUploadRef} accept=".pdf, .jpg, .jpeg, .png" onSelect={(e) => uploadFiles(e)}
                    auto name={`expenseDocument`} multiple
                    emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>} customUpload={true} />


                  {/* <FileUpload onRemove={(e) => formik.setFieldValue(`userExpenses[0].expenseDocument`, formik.values.userExpenses[0].expenseDocument.filter(item => item?.fileName.split('-')[1] !== e?.file?.name))}
                    maxFileSize={2097152} ref={fileUploadRef} accept=".pdf, .jpg, .jpeg, .png" onSelect={(e) => uploadFiles(e, 0, "")}
                    auto name={`userExpenses[0].expenseDocument`} multiple
                    emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>} customUpload={true} /> */}

                </div>
                {getFormErrorMessage('trainingDocument')}
              </div>
              <div className="col-6">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Training Learnings
                </label>
                <div className="p-inputgroup flex-1">
                  <InputTextarea name="trainingLearning" value={formik.values.trainingLearning} onChange={formik.handleChange} placeholder="Enter Your Learnings" rows={4} className="w-full" style={{ background: "#fff" }} />
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="text" className="font-bold block mb-2 training-heading">
                  Learning apply on project
                </label>
                <div className="p-inputgroup flex-1">
                  <InputTextarea name="learningApplyOnProject" value={formik.values.learningApplyOnProject} onChange={formik.handleChange} placeholder="Enter Project Name" rows={4} className="w-full" style={{ background: "#fff" }} />
                </div>
              </div>

              <div className="col-6">
                <Button label='Update' icon='pi pi-save' severity='primary' className='mr-1' />
                {/* <button aria-label="submit" class="p-button p-component p-button-primary mt-2" type="submit" data-pc-name="button" data-pc-section="root">
                  <span class="p-button-icon p-c p-button-icon-left pi pi-check" data-pc-section="icon"></span>
                  <span className="p-button-label p-c" data-pc-section="label">Submit{" "}</span>
                </button> */}
              </div>
            </div>
          </div>
        </form>
      </div>




    </>
  )
}
export default UpdateEmpTrainingDetail;
